import React from 'react';
import {IndexLink,Link, withRouter} from 'react-router';
import { connect } from 'react-redux';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import axios from 'axios';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
let querystring = require('querystring');
import {Player, BigPlayButton, ControlBar} from 'video-react';

import ReactGA from 'react-ga';

import DatePicker from 'react-datepicker';
import moment from 'moment';

import 'react-datepicker/dist/react-datepicker.css';
import * as commonApi from "../../../api/common-api";
import * as userApi from "../../../api/user-api";
import ReadMoreReact from 'read-more-react';

const styles = {
    title: {
        fontSize: '14px',
        color: '#4d4d4d',
        fontWeight: '600',
        marginBottom: '10px',
    },
    iconStyle: {
        width: '18px',
        height: '18px',
        marginRight: '5px'
    },
    labelStyle: {
        lineHeight: '16px',
        fontFamily: 'inherit',
        fontSize: '13px',
        color: '#000',
        width: 'auto'
    },
};

class Boosted extends React.Component{
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);

        this.state = {
            cards: [],
            info_bid: {},

            //layout of right
            is_mobile: false,
        };
    }

    componentWillMount() {
        this.getInfoBoost();
        this.getCreditPayment();
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {}

    getInfoBoost () {
        let url = '/code/api_feeds.php?api=getInfoBoost';
        let data = new FormData();
        data.append('jobs_id', this.props.feeditem.id_feed);
        axios.post(url, data)
            .then(response => {
                this.setState({info_bid: response.data.data});
            }).catch(error => {});
    }

    getCreditPayment () {
        let url = '/code/api_jobs.php?api=preCreditPayment';
        let data = new FormData();
        axios.post(url, data)
            .then(response => {
                let cards = [];
                if (response.data.status >= 1) {
                    let cardLst = response.data.data;
                    for (let index = 0; index < cardLst.length; ++index) {
                        let card = cardLst[index];
                        if (card.default_card === '1') {
                            cards.push(<span><img src="/static/img/appimg/mc_vrt_opt_pos_46_1x.png" className={"align-middle"}/>MasterCard ending in {card.card_last4}</span>);
                        }
                    }
                }
                if (cards.length <= 0) cards.push(<div><span>Please add your payment method  </span> <Link to={"/payment/setting"} target="_blank">Add</Link></div>)
                this.setState({cards: cards});
            }).catch(error => {});
    }

    handleClose = (event) => {
        this.props.handleBoostedClose();
    }

    //layout
    handleClickMobile = (mobile) => {
        this.setState({is_mobile: mobile});
    }

    render() {
        let videoUrl = <img src={this.props.feeditem.imgUrl}/>
        if (this.props.feeditem.job_video_file) {
            videoUrl= <PlayerTest videoUrl={this.props.feeditem.job_video_file.link_file}/>
            if (this.props.feeditem.job_video==2) {
                videoUrl = <img src={this.props.feeditem.job_video_file.link_file}/>
            }
        }

        let onsite = '';
        if (this.props.feeditem.job_tracking != '') {
            onsite = <a className={"btn_v btn_cancel apply1 t-bold t-14"}> One-Click Apply </a>;
            if (this.props.feeditem.job_tracking_url != '') {
                onsite = <a className={"btn_v btn_cancel apply1 t-bold t-14"}> Apply on Site </a>;
            }
            if (this.props.feeditem.job_tracking == '1') {
                onsite = <a className={"btn_v btn_cancel apply1 t-bold t-14"}> Apply </a>;
            }
        }

        return (
            <div id={"job-create"} className={'item clear'}>
                <button className="close" onClick={this.handleClose.bind(this)}>X</button>
                <h2>View Results</h2>
                <div className={"col-xs-12 content-block pd0"}>
                    <div className={"col-xs-5 content-left pl0"}>
                        <div className={"col-xs-12 pd0"}>
                            <ul className={"review-block"}>
                                <li><span className={"bl"}><img src="/static/img/appimg/b-icon0.png"/>Status</span><span className={"br"}>In Review</span></li>
                                <li><span className={"bl"}><img src="/static/img/appimg/b-icon1.png"/>Objective</span><span className={"br"}>Applications</span></li>
                                <li><span className={"bl"}><img src="/static/img/appimg/b-icon2.png"/>Total budget</span><span className={"br"}>${this.state.info_bid.total}</span></li>
                                <li><span className={"bl"}><img src="/static/img/appimg/b-icon3.png"/>Amount spent</span><span className={"br"}>$0.00</span></li>
                                <li><span className={"bl"}><img src="/static/img/appimg/b-icon4.png"/>Duration</span><span className={"br"}>{this.state.info_bid.durantion}</span></li>
                                <li><span className={"bl"}><img src="/static/img/appimg/b-icon5.png"/>End date</span><span className={"br"}>{this.state.info_bid.end_date}</span></li>
                                <li><span className={"bl"}><img src="/static/img/appimg/b-icon5.png"/>Date created</span><span className={"br"}>{this.state.info_bid.cre_data}</span></li>
                                <li><span className={"bl"}><img src="/static/img/appimg/b-icon6.png"/>Created by</span><span className={"br"}>{this.state.info_bid.author}</span></li>
                                <li><span className={"bl"}><img src="/static/img/appimg/b-icon7.svg"/>Payment method</span><span className={"br"}>{this.state.cards}</span></li>
                            </ul>
                        </div>
                    </div>
                    <div className={"col-xs-7 pd0"}>
                        <div className={'top_content'}>
                            <div className={this.state.is_mobile?'':'active'} onClick={this.handleClickMobile.bind(this, false)}>Desktop News Feed</div>
                            <div className={this.state.is_mobile?'active':''} onClick={this.handleClickMobile.bind(this, true)}>Mobile News Feed</div>
                        </div>
                        <div className={this.state.is_mobile?'content-right plr20':'content-right plr7'}>
                            <div className="page_course_box feed_section">
                                <div className="feed_top_box">
                                    <div className="feed_top_left">
                                        <a href="javascript:void(0)">
                                            <img
                                                className="img_circle"
                                                src={this.props.feeditem.avata}
                                            />
                                        </a>
                                    </div>
                                    <div className="feed_top_right">
                                        <div className="feed_name user_name t-14 t-bold">
                                            <a href="/company">{this.props.feeditem.name}</a></div>
                                        <div className="feed_user_major t-12 t-normal">{this.props.feeditem.sub_name}</div>
                                    </div>
                                </div>
                                <div className="feed_mid_box">
                                    <div className="feed_content">
                                        <div className="bannerImage">
                                            {videoUrl}
                                        </div>
                                        <div className="feed_title">{this.props.feeditem.title_job}</div>
                                        <div className="job_content t-14">
                                            <div className="feed_content_class t-14"
                                                 dangerouslySetInnerHTML={{__html: <ReadMoreReact text={this.props.feeditem.des_job}/>}}/>
                                        </div>
                                        <div className="feed_local">
                                            <div className="text-left t-bold t-14">
                                                <span className={"pr10"}>{this.props.feeditem.location_job}</span>
                                                <span className={"pr10"}>{this.props.feeditem.employment_job}</span>
                                                <span className={"pr10"}>{this.props.feeditem.salary_job}</span>
                                                {this.state.txt_opend}
                                            </div>
                                            <div className="btn-right">
                                                {onsite}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="feed_bot_box">
                                    <div className="like_box"><img src="/static/img/appimg/icon_like.png"/>
                                        &nbsp;&nbsp;&nbsp;
                                        <a className="like_btn">
                                            Like&nbsp;
                                        </a>
                                    </div>
                                    <div className="comment_box"><img
                                        src="/static/img/appimg/icon_com.png"/>&nbsp;&nbsp;&nbsp;
                                        <a>
                                            Comment&nbsp;(0)
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"btn-block clear"}>
                    <span className={"text-left"}>By clicking add Budget, you agree Versity’s <a>Term and Conditions</a>   |   <a>Help Center</a></span>
                    <div className={"text-right"}>
                        <div className={"btn btn-default btn-md mr10"} onClick={this.handleClose.bind(this)}>Close  </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Boosted;


/** WEBPACK FOOTER **
 ** ./src/client/app/eappcomponents/commons/ppc/boosted.js
 **/